import React, { useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { pressureAltitude, densityAltitude } from "../utils/pressureAltitude";
import { fmtFt0 } from "../utils/wcaMath";


function DensityAltPage() {
  const [departElevation, setDepartElevation] = useState("1277");
  const [departAltimeter, setDepartAltimeter] = useState("30.14");
  const [departOat, setDepartOat] = useState("24");

  const [arrivalElevation, setArrivalElevation] = useState("1061");
  const [arrivalAltimeter, setArrivalAltimeter] = useState("29.92");
  const [arrivalOat, setArrivalOat] = useState("25");

  const departurePressureAltitudeFt = useMemo(() => {
    return pressureAltitude(Number(departElevation), Number(departAltimeter));
  }, [departElevation, departAltimeter]);

  const departureDensityAltitudeFt = useMemo(() => {
    return densityAltitude(Number(departurePressureAltitudeFt), Number(departOat));
  }, [departurePressureAltitudeFt, departOat]);

  const arrivalPressureAltitudeFt = useMemo(() => {
    return pressureAltitude(Number(arrivalElevation), Number(arrivalAltimeter));
  }, [arrivalElevation, arrivalAltimeter]);

  const arrivalDensityAltitudeFt = useMemo(() => {
    return densityAltitude(Number(arrivalPressureAltitudeFt), Number(arrivalOat));
  }, [arrivalPressureAltitudeFt, arrivalOat]);

  return (
    <>
    <section className="tool-hero">
    
      <h1>Density Altitude Calculator</h1>
      <p style={{fontSize: 18}} >
        Calculate density altitude using field elevation, outside air temperature (OAT),
        and altimeter setting. Density altitude directly affects aircraft performance,
        including takeoff distance, landing distance, climb rate, and engine efficiency.</p>     
    
    </section>
    <div className="ad-banner">Ad Space</div>
  
        {/* ============================================================
                DENSITY ALTITUDE / PRESSURE ALTITUDE CALCULATOR
                ============================================================ */}
            <section className="home-tool-section">
              

              <p>
                Enter field elevation, altimeter setting, and outside air temperature
                to calculate pressure altitude and density altitude.
              </p>
            

      
          <div className="pa-da-grid">
            {/* ===================== DEPARTURE ===================== */}
            <div className="pa-da-block">
              <h4>Departure</h4>

              <label>Elevation (MSL)</label>
              <input
                value={departElevation}
                onChange={(e) => setDepartElevation(e.target.value)}
              />

              <label>Altimeter (inHg)</label>
              <input
                value={departAltimeter}
                onChange={(e) => setDepartAltimeter(e.target.value)}
              />

          <label>OAT (°C)</label>
          <input
            value={departOat}
            onChange={(e) => setDepartOat(e.target.value)}
          />

          <div className="pa-da-results">
            <div className="pa-da-result-row">
            <span className="pa-da-result-label">Pressure Altitude:</span>
            <span className="pa-da-result-value">
              {fmtFt0(departurePressureAltitudeFt)}
            </span>
            <span className="pa-da-result-unit">ft</span>
          </div>

          <div className="pa-da-result-row">
            <span className="pa-da-result-label">Density Altitude:</span>
            <span className="pa-da-result-value">
              {fmtFt0(departureDensityAltitudeFt)}
            </span>
            <span className="pa-da-result-unit">ft</span>
          </div>
        </div>
        </div>

        {/* ===================== ARRIVAL ===================== */}

        <div className="pa-da-block">
          <h4>Arrival</h4>

          <label>Elevation (MSL)</label>
          <input
            value={arrivalElevation}
            onChange={(e) => setArrivalElevation(e.target.value)}
          />

          <label>Altimeter (inHg)</label>
          <input
            value={arrivalAltimeter}
            onChange={(e) => setArrivalAltimeter(e.target.value)}
          />

          <label>OAT (°C)</label>
          <input
            value={arrivalOat}
            onChange={(e) => setArrivalOat(e.target.value)}
          />

          <div className="pa-da-results">
            <div className="pa-da-result-row">
            <span className="pa-da-result-label">Pressure Altitude:</span>
            <span className="pa-da-result-value">
              {fmtFt0(arrivalPressureAltitudeFt)}
            </span>
            <span className="pa-da-result-unit">ft</span>
          </div>

          <div className="pa-da-result-row">
            <span className="pa-da-result-label">Density Altitude:</span>
            <span className="pa-da-result-value">
              {fmtFt0(arrivalDensityAltitudeFt)}
            </span>
            <span className="pa-da-result-unit">ft</span>
          </div>
         </div>
        </div>
      </div>
      <h2>Related Tools</h2>

        <p>
          <Link to="/">HomePage</Link> |
          <Link to="/vsps">Vspeed</Link> |
          <Link to="/rollout">Ground Roll</Link> |
          <Link to="/navlog">NavLog</Link> |
          <Link to="/wtbals">Weight & Balance</Link> |
          <Link to="/cw">Crosswind/Headwind</Link> |
          <Link to="/mnvr">Maneuvers</Link> |
          <Link to="/airframe-powerplant">Airframe & Powerplant</Link> |
          <Link to="/airplane-prebuy">Airplane Prebuy Checklist</Link> |
          <Link to="/adjustable-amortization">Aircraft Loan</Link>
        </p>
      <div className="ad-banner">Ad Space</div>
      <h2>What is Density Altitude?</h2>

          <p>
          Density altitude is pressure altitude corrected for non-standard temperature.
          Higher density altitude results in reduced aircraft performance.
          </p>

          <h2>Why It Matters</h2>

          <p>
          High density altitude conditions can significantly increase takeoff distance
          and reduce climb performance, especially in high temperature and high elevation environments.
          </p>
          </section>
          </>
  );
}
export default DensityAltPage;